/**
 * @generated SignedSource<<8c735b6e872015e2d2d240790d774fef>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphConversation_AtlassianSearchPage$data = {
  readonly entity: {
    readonly displayName?: string | null | undefined;
    readonly memberCount?: AGG$Long | null | undefined;
    readonly members?: ReadonlyArray<{
      readonly __typename: "ExternalUser";
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly integrationId: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly subtype: string | null | undefined;
  readonly tabs: ReadonlyArray<{
    readonly __typename: "SearchResultGraphTab";
  }> | null | undefined;
  readonly title: string;
  readonly url: string;
  readonly workspaceName: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"messageBody_AtlassianSearchPage" | "tabs_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphConversation_AtlassianSearchPage";
};
export type searchGraphConversation_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphConversation_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphConversation_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v3 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphConversation_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "messageBody_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "tabs_AtlassianSearchPage"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workspaceName"
    },
    {
      "concreteType": "SearchResultGraphTab",
      "kind": "LinkedField",
      "name": "tabs",
      "plural": true,
      "selections": (v5/*: any*/)
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "displayName"
            },
            {
              "kind": "ScalarField",
              "name": "memberCount"
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "members",
              "plural": true,
              "selections": (v5/*: any*/)
            }
          ],
          "type": "ExternalConversation"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v4/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "0431480ef125ed314d51c01fc9cf0f80";

export default node;
